export enum AppStoreVariant {
  IOS_NON_SAFARI_BROWSER = 'ios-non-safari-browser',
  ANDROID = 'android',
  DETECT_DEVICE = 'detect-device'
}
